export default __webpack_public_path__ + "static/media/fofBG.bc002d52.svg";